import { AIRPORT_FROM, AIRPORT_TO } from 'components/utils/airportTypes';
import merge from 'lodash/merge';

const AIRPORT_NAME = "torp";
const AIRPORT_NAME_OSLO = "oslo torp";

class RevertAirportHelper {
  constructor(props, clickedAirport, airportType) {
    this.props = props;
    this.airportType = airportType;
    this.departureAirport = this.clone(props.airportFrom);
    this.returnAirport = this.clone(props.airportTo);
    this.previousAirport = null;
    this.newAirport = {
      airportType: airportType,
      id: clickedAirport.id ? clickedAirport.id : null,
      label: clickedAirport.name,
      isAirport: clickedAirport.is_airport ? true : false
    }
    this.torpAirport = this.setupTorp();
    this.setupNewFlight();
  }

  setupNewFlight() {
    if (this.airportType === AIRPORT_FROM) {
      this.previousAirport = this.clone(this.departureAirport);
      this.departureAirport = this.clone(this.newAirport);
      this.returnAirport = this.changeFlight(
        this.departureAirport,
        this.returnAirport,
        this.previousAirport
      );
    } else {
      this.previousAirport = this.clone(this.returnAirport);
      this.returnAirport = this.clone(this.newAirport);
      this.departureAirport = this.changeFlight(
        this.returnAirport,
        this.departureAirport,
        this.previousAirport
      );
    }
  }

  changeFlight(firstAirport, secondAirport, previousAirport, type) {
    if (secondAirport === null) {
      return null;
    }

    if (firstAirport.isAirport === secondAirport.isAirport) {
      if (secondAirport.isAirport) {
        return previousAirport;
      } else {
        return this.torpAirport;
      }
    } else {
      return secondAirport;
    }
  }

  getDepartureAirport() {
    return this.setType(this.departureAirport, AIRPORT_FROM);
  }

  getReturnAirport() {
    return this.setType(this.returnAirport, AIRPORT_TO);
  }

  setType(object, type) {
    object["airportType"] = type;
    return object;
  }

  clone(obj) {
    return merge({}, obj);
  }

  setupTorp() {
    var torp = this.findTorp();
    if (torp) {
      return {
        id: torp.id,
        label: torp.name,
        isAirport: true
      };
    } else {
      return null;
    }
  }

  findTorp() {
    const { airports } = this.props;
    for (var i = 0; i < airports.length; i++) {
      var airport = airports[i];
      if (airport.name.toLowerCase() === AIRPORT_NAME ||
        airport.name.toLowerCase() === AIRPORT_NAME_OSLO
      ) {
        return airport;
      }
    }
  }

}

export default RevertAirportHelper;
